import React from "react";
//import { useHistory } from "react-router-dom";
import { Fragment } from "react";
import { Button, Modal, Rate, Drawer } from "antd";
import { useState, useEffect } from "react";
import "./Rating.css";
import moment from "moment";
import { useDispatch } from "react-redux";
import { postRatingreviews } from "../../redux/actions";
import { putRatingreviews } from "../../redux/actions";
import { getImage } from "../../utilities/storageOperations/downloadURL";

import { useLocation } from "react-router-dom";

const Rating = (props) => {
  const location = useLocation();

  const [isModalVisible, setIsModalVisible] = useState(props.modal);
  const [wordCount, setWordCount] = useState(0);
  const [showClose, setShowClose] = useState(false);
  const [review, setReview] = useState(null);
  const [countCom, setCountCom] = useState();
  const [countWork, setCountWork] = useState();
  const [countRec, setCountRec] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [notEditable, setNotEditable] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [BidId, setBidId] = useState(false);
  const [ratings_Id, setRatings_Id] = useState(false);
  const [skill_listing_title, setSkill_listing_title] = useState(
    "Skill listing Title Lorem Ipsum"
  );
  const [job_title, setJob_title] = useState("ob Title Lorem Ipsum");
  const [candidate_name, setCandidate_name] = useState("Candidate name");
  const [dateFrom, setDateFrom] = useState("MM/DD/YYYY");
  const [dateTo, setDateTo] = useState("MM/DD/YYYY");
  const [imageUrl, setimageUrl] = useState("");

  useEffect(() => {
    if (location.state) {
      setBidId(location.state.bidId);
      setJob_title(location.state.job_title);
      setCandidate_name(location.state.candidate_name);

      if (location.state.image) {
        getImage(location.state.image)
          .then((result) => {
            setimageUrl(result);
          })
          .catch(() => {
          });
      }
    }
  }, [location.state]);

  useEffect(() => {
    setBidId(props.bidId);

    setSkill_listing_title(props.skill_listing_title);
    setJob_title(props.job_title);
    setCandidate_name(props.candidate_name);

    setDateFrom(moment(props.date_from).format("MMMM DD, YYYY"));
    setDateTo(moment(props.date_to).format("MMMM DD, YYYY"));

    if (props.image) {
      getImage(props.image)
        .then((result) => {
          setimageUrl(result);
        })
        .catch(() => {
        });
    }

    if (props.isEdit) {
      setIsEdit(true);
      setNotEditable(true);
      if (props.ratings) {
        setCountCom(props.ratings.ConsultantRating?.Communication);
        setCountWork(props.ratings.ConsultantRating?.WorkingKnowledge);
        setCountRec(props.ratings.ConsultantRating?.Recommendation);
        setReview(props.ratings.Comment);
        setWordCount(props.ratings.Comment?.length);
        setRatings_Id(props.ratings._id);
      }
    }
  }, [props]);

  const dispatch = useDispatch();
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setShowClose(true);
    if (isEdit === false) {
      dispatch(
        postRatingreviews({
          BidId: BidId,
          Comment: review,
          ConsultantRating: {
            Communication: countCom,
            WorkingKnowledge: countWork,
            Recommendation: countRec,
          },
        })
      );
    } else {
      dispatch(
        putRatingreviews({
          Ratings_id: ratings_Id,
          Comment: review,
          ConsultantRating: {
            Communication: countCom,
            WorkingKnowledge: countWork,
            Recommendation: countRec,
          },
        })
      );
    }
  };

  const handleEdit = () => {
    setShowClose(false);
    //setIsModalVisible(true);
    setNotEditable(false);
    setIsEdit(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    props.setModal(false);
  };

  const handleCancelClick = () => {
    setIsModalVisible(false);
    setShowClose(false);
    props.setModal(false);
  };

  const handleClose = () => {
    setIsModalVisible(false);
    setShowClose(false);
    props.setModal(false);
  };

  const handleReviewChange = (event) => {
    setReview(event.target.value);
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <Fragment>
      {windowDimensions.width > 769 ? (
        <Modal
          title="Rate Candidate"
          visible={isModalVisible}
          footer={
            !notEditable ? (
              <div className="Footer">
                <Button
                  style={{
                    color: "green",
                    width: "60%",
                    backgroundColor: "white",
                    borderRadius: "4px",
                  }}
                  onClick={handleCancel}
                  className="skip"
                >
                  Skip
                </Button>
                <Button
                  disabled={wordCount === 0 ? true : false}
                  style={
                    wordCount > 0
                      ? {
                        color: "white",
                        width: "60%",
                        backgroundColor: "green",
                        borderRadius: "4px",
                      }
                      : {
                        color: "gray",
                        width: "60%",
                        backgroundColor: "#f2f2f2",
                        borderRadius: "4px",
                      }
                  }
                  onClick={handleOk}
                  className={wordCount === 0 && "submit"}
                >
                  Submit
                </Button>
              </div>
            ) : (
              <div className="Footer-close">
                <Button
                  style={{
                    color: "green",
                    width: "100%",
                    backgroundColor: "white",
                    borderRadius: "4px",
                    border: "1px solid green",
                  }}
                  onClick={handleEdit}
                  className="edit"
                >
                  Edit
                </Button>
                <Button
                  style={{
                    color: "green",
                    width: "100%",
                    backgroundColor: "white",
                    borderRadius: "4px",
                    border: "1px solid green",
                  }}
                  onClick={handleClose}
                  className="close"
                >
                  Close
                </Button>
              </div>
            )
          }
          closable={true}
          onCancel={handleCancelClick}
          className="simple-modal"
        >
          <div className="picDiv">
            <img
              className="recipent_image"
              src={imageUrl}
              alt="recipent image"
            />
          </div>

          <div className="descrDiv">
            <div style={{ marginBottom: "-15px", color: "#4e4e4e" }}>
              {skill_listing_title}
            </div>
            <br />
            <div style={{ marginBottom: "-15px", color: "#4e4e4e" }}>
              {job_title}
            </div>
            <br />
            <div
              style={{
                marginBottom: "-15px",
                color: "black",
                fontWeight: "bolder",
              }}
            >
              {candidate_name}
            </div>
            <br />
            <div style={{ marginBottom: "10px", color: "#7e7e7e" }}>
              {dateFrom} - {dateTo}
            </div>
            <br />
          </div>
          <div className="ratingDiv">
            <div className="COL-flex">
              <div style={{ fontWeight: "bold" }}>Communication</div>
              <br />
              <div style={{ fontWeight: "bold" }}>Work knowledge</div>
              <br />
              <div style={{ fontWeight: "bold" }}>Would recommend</div>
            </div>
            <div className="COL-flex">
              <Rate
                defaultValue={countCom}
                style={{ marginBottom: "10px", marginTop: "-5px" }}
                allowHalf
                onChange={(value) => {
                  setCountCom(value);
                }}
                value={countCom}
              />
              <br />

              <Rate
                defaultValue={countWork}
                style={{ marginBottom: "10px" }}
                allowHalf
                onChange={(value) => {
                  setCountWork(value);
                }}
                value={countWork}
              />
              <br />

              <Rate
                defaultValue={countRec}
                style={{ marginBottom: "10px" }}
                allowHalf
                onChange={(value) => {
                  setCountRec(value);
                }}
                value={countRec}
              />
            </div>
          </div>
          <br />
          {!notEditable ? (
            <div className="reviewDiv">
              Share your experience below
              <br />
              <textarea
                value={review}
                onChange={(e) => {
                  setWordCount(e.target.value.length);
                  handleReviewChange(e);
                }}
                maxlength="700"
                className={wordCount < 700 ? "normal-drawer" : "full-drawer"}
                placeholder="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
              />
              <div id={wordCount < 700 ? "the-count" : "count-finish"}>
                <span id="current">{wordCount}</span>
                <span id="maximum">/ 700</span>
              </div>
            </div>
          ) : (
            <div>{review}</div>
          )}

          {!showClose && wordCount >= 700 && (
            <div style={{ color: "red" }}>
              characters should be less than or equal to 700
            </div>
          )}
          <br />
        </Modal>
      ) : (
        <div className="ratings-drawer">
          <Drawer
            placement="top"
            title="Rate Candidate"
            visible={isModalVisible}
            footer={
              !showClose ? (
                <div className="Footer">
                  <Button
                    style={{
                      color: "green",
                      width: "60%",
                      backgroundColor: "white",
                      borderRadius: "4px",
                    }}
                    onClick={handleCancel}
                    className="skip"
                  >
                    Skip
                  </Button>
                  <Button
                    disabled={wordCount === 0 ? true : false}
                    style={
                      wordCount > 0
                        ? {
                          color: "white",
                          width: "60%",
                          backgroundColor: "green",
                          borderRadius: "4px",
                        }
                        : {
                          color: "gray",
                          width: "60%",
                          backgroundColor: "#f2f2f2",
                          borderRadius: "4px",
                        }
                    }
                    onClick={handleOk}
                    className={wordCount === 0 && "submit"}
                  >
                    Submit
                  </Button>
                </div>
              ) : (
                <div className="Footer-close">
                  <Button
                    style={{
                      color: "green",
                      width: "100%",
                      backgroundColor: "white",
                      borderRadius: "4px",
                      border: "1px solid green",
                    }}
                    onClick={handleClose}
                    className="close"
                  >
                    Close
                  </Button>
                </div>
              )
            }
            closable={true}
            onCancel={handleCancelClick}
            className="simple-drawer"
          >
            <div className="picDiv">
              <img
                className="recipent_image"
                src={imageUrl}
                alt="recipent image"
              />
            </div>

            <div className="descrDiv">
              <div style={{ marginBottom: "-15px", color: "#4e4e4e" }}>
                {skill_listing_title}
              </div>
              <br />
              <div style={{ marginBottom: "-15px", color: "#4e4e4e" }}>
                {props.job_title}
              </div>
              <br />
              <div
                style={{
                  marginBottom: "-15px",
                  color: "black",
                  fontWeight: "bolder",
                }}
              >
                {candidate_name}
              </div>
              <br />
              <div style={{ marginBottom: "10px", color: "#7e7e7e" }}>
                {dateFrom} - {dateTo}
              </div>
            </div>
            <div className="ratingDiv-drawer">
              <div className="COL-flex-drawer">
                <div style={{ fontWeight: "bold" }}>Communication</div>
                <br />
                <div style={{ fontWeight: "bold" }}>Work knowledge</div>
                <br />
                <div style={{ fontWeight: "bold" }}>Would recommend</div>
              </div>
              <div className="COL-flex-drawer">
                <Rate
                  defaultValue={countCom}
                    style={{ marginBottom: "10px", marginTop: "-5px" }}
                    allowHalf
                  onChange={(value) => {
                    setCountCom(value);
                  }}
                  value={countCom}
                />
                <br />
                <Rate
                    defaultValue={countWork}
                    allowHalf
                  style={{ marginBottom: "10px" }}
                  onChange={(value) => {
                    setCountWork(value);
                  }}
                  value={countWork}
                />

                <br />
                <Rate
                  defaultValue={countRec}
                    style={{ marginBottom: "10px" }}
                    allowHalf
                  onChange={(value) => {
                    setCountRec(value);
                  }}
                  value={countRec}
                />
              </div>
            </div>
            <br />
            {!showClose ? (
              <div className="reviewDiv">
                Share your experience below
                <br />
                <textarea
                  value={review}
                  onChange={(e) => {
                    setWordCount(e.target.value.length);
                    handleReviewChange(e);
                  }}
                  maxlength="700"
                  className={wordCount < 700 ? "normal-drawer" : "full-drawer"}
                  placeholder="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
                />
                <div
                  id={
                    wordCount < 700 ? "the-count-drawer" : "count-finish-drawer"
                  }
                >
                  <div id="current">{wordCount}</div>
                  <div id="maximum">/ 700</div>
                </div>
              </div>
            ) : (
              <div>{review}</div>
            )}

            {!showClose && wordCount >= 700 && (
              <div style={{ color: "red" }}>
                characters should be less than or equal to 700
              </div>
            )}
            <br />
          </Drawer>
        </div>
      )}
    </Fragment>
  );
};

export default Rating;
